// Generated by CoffeeScript 2.7.0
var TagNamecardSetting;

import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

export default TagNamecardSetting = {
  components: {
    filter_options: FilterOptions
  },
  props: {
    initialTagIds: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  // allowedNameOrganizations:
  //   type: Array
  //   default: []
  // initailOrganizationId:
  //   type: [String, Number]
  data: function() {
    return {
      tagGroups: [],
      tag_ids: this.initialTagIds
    };
  },
  template: `<div class="tag-namecard-setting">
  <div class="tab-section message-tags">
    <h4 class="tab-section-title">消息标签</h4>
    <div class="tab-section-content">
      <filter_options :groupedOptions='tagGroups' :multiple='true' @valueChanged='updateTags' ref='tags' />
    </div>
  </div>
</div>`,
  created: function() {
    return this.getMessageTags();
  },
  methods: {
    getData: function() {
      return {
        tag_ids: this.tag_ids
      };
    },
    updateTags: function() {
      return this.tag_ids = _.pluck(this.$refs.tags.selectedOptions, 'id');
    },
    getMessageTags: function() {
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor('/tag_groups/receipt.json'), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json'
      }).done((tag_groups, xhr) => {
        var selectedTagIds;
        selectedTagIds = this.initialTagIds;
        return this.tagGroups = _.map(tag_groups, function(group) {
          group.multiple = true;
          group.options = group.tags;
          _.each(group.options, function(option) {
            return option._selected = _.contains(selectedTagIds, option.id);
          });
          return group;
        });
      });
    }
  }
};
